import { all } from "redux-saga/effects"
import { mainSagas } from "./ducks/main"
import { landingSagas } from "./ducks/landing"
import { uploadSagas } from "./ducks/upload"
import { regionSagas } from "./ducks/region"
import { webTrackSagas } from "./ducks/webTrack"

function* rootSaga() {
  let sagas = [].concat(mainSagas, landingSagas, uploadSagas, regionSagas, webTrackSagas)
  yield all(sagas)
}

export default rootSaga
